// extracted by mini-css-extract-plugin
export default {"container":"bP-z","dimension":"cP-z","dimensionLabels":"dP-z"};